import { Component } from 'react'
import * as blUrls from 'lib/urls'
import Link from 'components/link'
import CategoryGrid from 'store/components/CategoryGrid'
import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'

export class AddFromBabylistStore extends Component {
  render() {
    return (
      <div>
        <p>
          Discover the best baby gear tested by our experts and real parents!{' '}
          <Link url={blUrls.registryDiscountPath} newWindow>
            Our registry discount
          </Link>{' '}
          gives you {CONFIG.store.registryDiscountPctDisplay} off items we sell
          2 months before baby arrives.
        </p>
        <CategoryGrid
          callout={{
            title: 'Free Shipping',
            message: `Orders $${FREE_SHIPPING_THRESHOLD}+`,
            small: true,
          }}
          categories={this.props.categories}
          useRouter={false}
          smColumns={4}
          smallGutter
        />
      </div>
    )
  }
}

export default AddFromBabylistStore
